var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12671 10.6031L3.79337 8.26977C3.53337 8.00977 3.12004 8.00977 2.86004 8.26977C2.60004 8.52977 2.60004 8.94311 2.86004 9.20311L5.65337 11.9964C5.91337 12.2564 6.33337 12.2564 6.59337 11.9964L13.66 4.93644C13.92 4.67644 13.92 4.26311 13.66 4.00311C13.4 3.74311 12.9867 3.74311 12.7267 4.00311L6.12671 10.6031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.d41affc26e78f0f7dd00c5b41a0587bf.svg";
export { ForwardRef as ReactComponent };